import { render, staticRenderFns } from "./AdditionalEmailConfirm.vue?vue&type=template&id=1712a6ea&"
import script from "./AdditionalEmailConfirm.vue?vue&type=script&lang=js&"
export * from "./AdditionalEmailConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports